module.exports = __webpack_public_path__ + "static/media/4.3b403af4.png";